import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import Particles from 'react-tsparticles';



export default class ImageRecord2 extends React.Component {
    componentDidMount(){
    }

    render(){
        const deg = {
            fontSize : '12px',
            //background: 'rgb(114,3,95)',
            background: 'linear-gradient(47deg, rgba(114,3,95,1) 0%, rgba(73,16,97,1) 16%, rgba(23,31,96,1) 26%, rgba(0,38,103,1) 44%, rgba(0,29,85,1) 63%, rgba(0,4,31,1) 100%)'
            // background: 'rgba(252,234,187,1)',
            // background: '-moz-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
            // background: '-webkit-gradient(left top, left bottom, color-stop(0%, rgba(252,234,187,1)), color-stop(42%, rgba(252,205,77,1)), color-stop(88%, rgba(248,182,5,1)), color-stop(91%, rgba(248,181,0,1)), color-stop(100%, rgba(251,223,147,1)))',
            // background: '-webkit-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
            // background: '-o-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
            // background: '-ms-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
            // background: 'linear-gradient(to bottom, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
            // filter: 'progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#fceabb\', endColorstr=\'#fbdf93\', GradientType=0 )'
        }
        
        
        const title = {
            textAlign: 'center',
            fontSize: '18px',
            color: 'white',
            fontFamily: "'Nunito', sans-serif",
            fontWeight: '800'
        }

        const mystyle = {
            maxWidth: '60%',
            height: 'auto'
        }
        
        const txt2 = {
            textAlign: 'center',
            fontSize: '14px',
            color : 'white',
            fontFamily: "'Nunito', sans-serif",
            fontWeight: '800'
        }

        const contimg = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }

        const list = {
            fontSize: '14px',
            color: 'white',
            fontFamily: "'Nunito', sans-serif",
            fontWeight: '800'
        }

        return(
            <Container style={deg} id="particles-js">
                <Row>
                    <Col style={title}>¡Gracias!</Col>
                </Row>
                <Row>
                    <Col style={txt2}>Estamos cargando tu respuesta, por favor espera unos segundos mas</Col>
                </Row>
                <Row>
                    <Col style={txt2}>Durante tu entrevista...</Col>
                </Row>
                <Row>
                    <Col xs={12} style={list}>
                        <ul> 
                            <li>Saluda sonriente y con un firme apretón de manos</li> 
                            <li>Llama al entrevistador por su nombre</li> 
                            <li>Cuando te sientes, hazlo con una postura recta y los dos pies apoyados en el suelo</li> 
                            <li>No cruces los brazos ni escondas tus manos</li>
                            <li>Mira al entrevistador a los ojos</li>
                            <li>Habla de forma clara, concisa y sin titubeos, utiliza un lenguaje sencillo y positivo</li>
                            <li>Sé sincero, no mientas</li>
                            <li>Muétrate educado, es importante decir "por favor", "gracias" </li>
                        </ul>
                    </Col>
                    <Col xs={12} style={contimg}>
                        <img  style={mystyle} id="img_loading" src={`${process.env.PUBLIC_URL}/images/InterPregTec/LibroV.png`} alt="Smiley face" />
                    </Col>
                </Row>
                <Particles/> 
            </Container>
        );
    }
}















